import _ from 'lodash';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { CorrectDatepicker, initDycolor, permissions, adapi, moment } from '~';
import { mapGetters, mapActions, mapState } from 'vuex';
import * as constants from '@/util/constants';

initDycolor('start-date-box', require(`${process.env.DYCOLOR_REQUIRE}./StartDateBox.scss`)); // eslint-disable-line

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'box-widget': BoxWidget,
    datepicker: CorrectDatepicker,
  },
  data() {
    return {
      loading: false,
      canceled: false,
      cancelLoading: false,
      internalValue: null,
    };
  },
  methods: {
    ...mapActions('campaign', ['setStartDate']),
    openPopup() {
      if (!this.readonly) {
        this.$refs.modal.show();
        this.internalValue = this.campaign.start_date;
      }
    },
    changeStartDate() {
      this.loading = true;

      const newStartDate = moment(this.internalValue).format('YYYY-MM-DD');

      this.setStartDate(newStartDate)
          .then(() => {
            this.loading = false;
            this.$toast.success({ message: this.$t('pos.campaign.start-date-changed') });
            this.cancel();
          })
          .catch(error => {
            this.loading = false;
            this.$toast.error({ message: error });
          });
    },
    cancel() {
      this.$refs.modal.hide();
    },
    cancelCampaign() {
      this.cancelLoading = true;
      return adapi.post(`campaigns/${this.campaign.code}/stop-campaign`)
        .then(result => {
          if (result) {
            this.$toast.success({ message: this.$t('pos.campaign.campaign-cancelled') });
            this.canceled = true;
          } else {
            this.$toast.warn({ message: this.$t('pos.campaign.campaign-cancel-error') });
            this.canceled = false;
          }
          this.cancelLoading = false;
        })
        .catch(e => {
          this.$toast.error({ message: e.toString() });
          this.canceled = false;
          this.cancelLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    ...mapState('genericConfig', ['config']),
    startDate() {
      const date = _.get(this.campaign, 'start_date', null);
      if (date) {
        return this.$t('fn.date', { timestamp: date });
      }
      return date;
    },
    disabled() {
      return {
        from: this.campaign.maxStartDate,
        to: this.campaign.minStartDate,
      };
    },
    displayNextIterationDate() {
      if (_.get(this.campaign, 'status.code', '') !== constants.STATUSES.ONL) {
        return false;
      }
      if (_.get(this.campaign, 'mode', '') === constants.MODES.oneoff) {
        return false;
      }
      return true;
    },
    canCancelCampaign() {
      return permissions.getPermissions(this.campaign).includes('stopCampaign');
    },
    nextIterationStartDate() {
      let periodCount = _.get(this.campaign, 'detail_duration', null);
      if (periodCount === null) {
        periodCount = _.get(this.config, 'campaign_subscription.period_count', constants.CAMPAIGN_SUBSCRIPTION.periodCount);
      }
      const periodType = _.get(this.config, 'campaign_subscription.period_type', constants.CAMPAIGN_SUBSCRIPTION.periodType);
      if (!constants.CAMPAIGN_SUBSCRIPTION.periodTypes.includes(periodType)) {
        return '-';
      }
      const periodLength = _.get(this.config, 'campaign_subscription.period_length', constants.CAMPAIGN_SUBSCRIPTION.periodLength);

      const startDate = moment(_.get(this.campaign, 'start_date', null));
      if (startDate.isValid()) {
        const curDate = moment();
        let iterationsCount = 0;
        while (startDate.isBefore(curDate)
          && (periodCount === null || iterationsCount < periodCount)) {
          startDate.add(periodLength, periodType);
          iterationsCount += 1;
        }
        if (periodCount === null || iterationsCount <= periodCount) {
          return this.$t('fn.date', { timestamp: startDate.toISOString() });
        }
      }

      return '-';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/start-date-box/StartDateBox.js